import { HttpStatusCode } from "axios";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { findCategory } from "../../../libs/category";
import { formatCount } from "../../../libs/numberFormat";
import { formatPostTitle } from "../../../libs/talk";

import { useSandiTalk } from "../../../contexts/boardContext";
import { getTalkPostList, TalkListItem } from "../../../services/talkServices";

import { PostListNoPostIcon } from "../PostList";

type Props = { url?: string; defaultPostList?: TalkListItem[] };

export default function TalkSummaryListView({ url, defaultPostList }: Props) {
  const navigate = useNavigate();
  const [talk] = useSandiTalk();
  const [postList, setPostList] = React.useState<
    (TalkListItem & { lifeCategoryName?: string })[]
  >(defaultPostList ?? []);

  useEffect(() => {
    const getPostList = async () => {
      const result = await getTalkPostList(url + "&pageSize=5" ?? "");
      if (result.status === HttpStatusCode.Ok) {
        setPostList(
          result.data.items.map((item) => {
            const category = findCategory(
              talk.categoryList ?? [],
              "lifeCategoryId",
              item.lifeCategoryId,
              0
            );
            return {
              ...item,
              lifeCategoryName:
                category && category.length
                  ? category?.[category?.length - 1]?.name
                  : "",
            };
          })
        );
      }
    };

    if (url) {
      getPostList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  useEffect(() => {
    setPostList(defaultPostList ?? []);
  }, [defaultPostList]);

  return (
    <div className="flex flex-col px-5 text-sm">
      {postList && postList.length > 0 ? (
        postList?.map((post) => (
          <div
            className="flex justify-between items-center cursor-pointer"
            key={post.lifePostId}
            onClick={() => navigate(`/talk/${post.lifePostId}`)}
          >
            <div className="flex items-center py-2.5 gap-2">
              {post?.categoryNameS && (
                <div className="px-2 py-0.5 bg-red-100 rounded-full">
                  {post.categoryNameS}
                </div>
              )}
              <div className="truncate max-w-[calc(100vw-86px-40px-10px)]">
                {formatPostTitle(post?.title, "제목 없음")}
              </div>
            </div>
            <div className="flex items-center gap-2 text-brand-neutral-50">
              <div>댓글 {formatCount(post.commentCount ?? 0)}</div>
              <div>조회 {formatCount(post.viewCount ?? 0)}</div>
            </div>
          </div>
        ))
      ) : (
        <div className="flex flex-col  items-center justify-center w-full h-40 gap-3 text-brand-neutral-60">
          <PostListNoPostIcon />
          게시글이 없어요
        </div>
      )}
    </div>
  );
}
